module.exports = __webpack_public_path__ + "static/media/manual-sz-status.42681e42.png";